import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'

  import UserLevelPointsProgressBar from '@/components/common/UserLevelPointsProgressBar.vue'
  import { VPopover } from 'v-tooltip'

  import { UserModule } from '@/store/modules/user'

  import useGamification from '@/composables/useGamification'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'UserLevelPoints',
  setup(__props) {

  const { userStats, totalPoints, currentLevel } = useGamification()
  const { translateString } = useI18n()

  const showNewPointsEarnedIndicator = ref(false)

  const companyName = computed(() => UserModule.currentCompany?.name)

  const pointsEarned = computed(() => {
    return UserModule.userGamificationPointsEarned
  })

  const currentLevelName = computed(() => {
    return currentLevel.value?.name
  })

  const previousLevelMaxPoints = computed(() => userStats.value?.previousLevelMaxPoints ?? 0)

  const currentLevelMaxPoint = computed(() => {
    return userStats.value?.level.maximumPoints ?? 0
  })

  const progressPercentage = computed(() => {
    const levelMaxPointDifferent = currentLevelMaxPoint.value - previousLevelMaxPoints.value
    return ((totalPoints.value - previousLevelMaxPoints.value) / levelMaxPointDifferent) * 100
  })

  const tooltipHeaderContent = computed(() => {
    return translateString('navigation.gamificationPoints.title', {
      totalPoints: totalPoints.value,
      nextLevelPoints: currentLevelMaxPoint.value,
    })
  })

  const placementText = computed(
    () => `${translateString('navigation.gamificationPoints.yourPlacementIn')} </br> <b>${companyName.value}</b>`,
  )

  const actualUserRank = computed(() => {
    if (!UserModule.userGamificationStats?.rank) return 0
    return UserModule.userGamificationStats.rank
  })

  const showCompanyRank = computed(() => {
    if (!UserModule.currentCompany?.showGamificationRank) return false
    return UserModule.currentCompany?.showGamificationRank && actualUserRank.value
  })

  const startTimer = () => {
    showNewPointsEarnedIndicator.value = true
    window.setTimeout(() => {
      showNewPointsEarnedIndicator.value = false
    }, 5000)
  }

  watch(pointsEarned, (points) => {
    if (points > 0) {
      startTimer()
    }
  })

return { __sfc: true,userStats, totalPoints, currentLevel, translateString, showNewPointsEarnedIndicator, companyName, pointsEarned, currentLevelName, previousLevelMaxPoints, currentLevelMaxPoint, progressPercentage, tooltipHeaderContent, placementText, actualUserRank, showCompanyRank, startTimer, computed, ref, watch, UserLevelPointsProgressBar, VPopover, UserModule, useGamification, useI18n }
}

})